import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const OptionsGrid = styled.div<{ $columns: 1 | 2; $rowCount: number }>`
    display: grid;
    column-gap: ${theme.space[8]};
    grid-auto-flow: column;
    grid-template-columns: repeat(${(props) => props.$columns}, minmax(0, 1fr));
    grid-template-rows: repeat(${(props) => props.$rowCount}, minmax(${theme.space[32]}, auto));
    width: 100%;
`;
